import { Component, ChangeDetectorRef, OnInit, HostListener } from '@angular/core';
import { NmdpWidget,  SESSION_TIMEOUT, NEW_SESSION, SESSION_CLOSED, SESSION_EXTENDED } from '@nmdp/nmdp-login';
import { NMDPHttpClientInterceptor } from '@nmdp/nmdp-login';
import { Router } from "@angular/router";
import { SubmissionHistoryService } from "./shared/services/submission-history.service";


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: [ './app.component.scss' ]
})
export class AppComponent implements OnInit {
    public title: string = 'Dashboard Project';
    public loginName: string = 'User';
    public version = {
        'application-version': '@project.version@',
        'application-name': 'Dashboard Project'
    }
    constructor ( public loginWidget: NmdpWidget, private ref: ChangeDetectorRef, private submissionHistoryService: SubmissionHistoryService,
                  private router: Router ) {
    }

    ngOnInit() {
        /*
         * initialize the SEL
         * 1) set the DIV where to display the login form
         * 2) subscribe to SSO events
         * 3) enable the NMDP HTTP Interceptor
         * 4) call the sessionInfo() API to determine whether the app is logged in.  This
         *    will then cause the emission of SESSION_CLOSED event (not logged in) or a NEW_SESSION
         *    event (already logged in)
         */
        this.loginWidget.setWidgetLocation('#nmdp-login-container');
        // register for NMDPInterceptor timeouts
        this.loginWidget.onEvent.subscribe(this.processSELEvent.bind(this));
        // enable the NMDP HTTP interceptor
        NMDPHttpClientInterceptor.enable(this.processTimeout.bind(this)); // process timeouts via subscribing to SESSION_TIMEOUT event
        // call the sessionInfo() API
        this.loginWidget.sessionInfo(); //get session info
    }



    // return a reference to the SEL
    getLoginWidget() {
        return this.loginWidget;
    }
    /*
     * global logout or signout
     * This destroys the SSO Session for this and other apps currently logged in
     */
    logout() {
        this.submissionHistoryService.clearUserData();
        this.submissionHistoryService.changeSampleSearchTable(null);
        this.submissionHistoryService.changeMessage(null);
        this.loginWidget.signout();
    }

    /*
     * Process a timeout event
     * The minimum processing needed is a call to this.loginWidget.getNewToken() , which
     * will determine if the user is still logged in.  If not, a login form will be shown.
     */
    processTimeout( timeoutType) {
        const oldSubject = this.loginWidget.subject;
        // check to see if session is active and retrieve a new token if appropriate
        // this will display a new login screen if needed
        this.loginWidget.getNewToken( rawtoken =>  {

            // This logic is only needed if there is information cached
            // specific to a user.  In that case, here is where one would
            // destroy the cached information when a different user has logged in

            if ( oldSubject != null && this.loginWidget.subject != oldSubject) {
                // clean out any old data from previous usage
                // as a different user may be at the browser

                alert(`a different user has logged in oldSubject ${oldSubject} new subject: ${this.loginWidget.subject}`);
            }
        });
    }
    handleError(error:Response) {
        let text:string = 'ERROR in call to Employee web service.  Status: '+error.status + '.  Text: '+error.statusText;
        alert(text);
    }
    /*
       * this function is executed when any SEL event is emitted
       * It manages the event -- adds it to the list of events
       *  and then acts accordingly.
       * for the SESSION_CLOSED event, it displays the SEL for a new login
       * for the NEW_SESSION event, it processes displays the token, Most apps will not need to do this , but may need to do something else.
       * for the SESSION_EXTENDED event, it makes sure that time left in session field is correctly displayed )
       * for the SESSION_TIMEOUT event, it calls the processTimeout function.
       */
    processSELEvent( event:any ) {

        switch(event.type){
            case SESSION_CLOSED:
                // detect the changes -- needed so that the login form will be displayed
                this.ref.detectChanges();
                // show the login.  Can also use this.nmdpWidget.getNewToken(), but that makes an extra call to Okta...
                this.loginWidget.showLogin();
                break;

            case NEW_SESSION:
                this.loginWidget.getAccessToken().then(token => {
                    return this.submissionHistoryService.getUserSearchInfo().catch(this.handleError);
                }).finally(() => {
                    this.ref.detectChanges();
                });
                break;

            case SESSION_EXTENDED:
                // No need to do anything with this event.
                // This event would need to be handled if there were a count-down timer or other time-limited
                // logic that needed to know when the SSO Session was extended
                break;

            case SESSION_TIMEOUT:
                this.processTimeout(event.data);
                break;

        }
    }
    @HostListener('window:mousedown',['$event'])
    mouseDownEvent(event:MouseEvent){
        if( this.loginWidget.isLoggedIn())
            this.loginWidget.markActive();
    }
}
